import script from "./ChatUserNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatUserNotes.vue?vue&type=script&setup=true&lang=js"

import "./ChatUserNotes.vue?vue&type=style&index=0&id=0a3b916a&lang=scss"

const __exports__ = script;

export default __exports__